<template>
  <div class="statistic" v-if="isView()">
    <div
        class="statistic-item badge bg-gray"
        :data-bs-toggle="isDeveloperUser() ? 'modal' : null"
        :data-bs-target="isDeveloperUser() ? ('#' + modalId + postId) : null"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-dna">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M14.828 14.828a4 4 0 1 0 -5.656 -5.656a4 4 0 0 0 5.656 5.656z" />
        <path d="M9.172 20.485a4 4 0 1 0 -5.657 -5.657" />
        <path d="M14.828 3.515a4 4 0 0 0 5.657 5.657" />
      </svg>
      <span class="count">{{ point }}</span>
    </div>
    <Teleport to="body" v-if="isDeveloperUser()">
      <ModalInfo :modal-id="modalId + postId" title="Рейтинг">
        <p v-if="comment.length" v-html="comment"></p>
        <p v-else>Данных пока нет.</p>
      </ModalInfo>
    </Teleport>
  </div>
</template>

<script>
import {defineComponent, watch, ref, toRaw} from "vue"
import StoreRegister from "@/plugins/store/services/StoreRegister"
import stores from "./stores"
import {
  getData as statisticGetData, storeName as statisticStoreName
} from "./services/statistic"
import ModalInfo from '@/components/modals/modal_info/ModalInfo'
import AuthStore from "@/modules/auth/services/Store"
import Helper from "@/services/Helper"

StoreRegister.handle(statisticStoreName, stores)

export default defineComponent({
  name: "StatisticPointChainRating",
  components: {
    ModalInfo,
  },
  props: {
    data: {
      type: Object,
      required: true
    },
  },
  setup(props) {
    let point = ref(0);
    let comment = ref('')
    const modalId = 'infoPointChainRating'
    const postId = props.data["post_id"]

    watch(() => statisticGetData(), (val) => {
      render(toRaw(val))
    })

    function render(payload) {
      if (payload[props.data["post_id"]] !== undefined) {
        point.value = payload[props.data["post_id"]]["val"]
        comment.value = payload[props.data["post_id"]]["comment"]
      }
    }

    function isView() {
      if (point.value === 0) {
        return false
      }

      return true
    }

    function isDeveloperUser() {
      if (!AuthStore.isAuth()) {
        return false
      }

      let data = AuthStore.getUserData()

      return Helper.isDeveloperUser(data["id"])
    }

    return {
      point,
      comment,
      postId,
      modalId,
      isView,
      isDeveloperUser,
    }
  }
})
</script>

<style scoped src="./css/style.css"></style>